export default __webpack_public_path__ + "static/media/stone2.ceaa8230.png";